/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getsyearlyreportrecord3Inputs */

const de__field_getsyearlyreportrecord3 = /** @type {(inputs: _Field_Getsyearlyreportrecord3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahresberichtversand`)
};

/**

* @param {_Field_Getsyearlyreportrecord3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getsyearlyreportrecord3 = /** @type {((inputs?: _Field_Getsyearlyreportrecord3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getsyearlyreportrecord3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getsyearlyreportrecord3(inputs)
});
export { _field_getsyearlyreportrecord3 as "_field_getsYearlyReportRecord" }